// extracted by mini-css-extract-plugin
export default {"btn":"Guide_btn__12jbh"};